import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type FilterSchemaCategoryFragment = { id: string, pk: number, parentId: number | null, name: string, slug: string, count: number, level: number };

export const FilterSchemaCategoryFragmentDoc = gql`
    fragment FilterSchemaCategory on CategorySchemaType {
  id
  pk
  parentId
  name
  slug
  count
  level
}
    `;